import { useEffect } from 'react'

export const useShowArrows = ({
  elementRef,
  setShowNavigation,
  sellers,
}: {
  elementRef: React.RefObject<HTMLDivElement>
  setShowNavigation: (arg: boolean) => void
  sellers: number
}) => {
  useEffect(() => {
    const element = elementRef.current

    if (!element) return
    const intersectionElement = new IntersectionObserver(
      (entries) => {
        let [observedElement] = entries

        for (const e of entries) {
          if (e.time > observedElement.time) observedElement = e
        }

        return setShowNavigation(!observedElement.isIntersecting)
      },
      {
        rootMargin: '0px',
        threshold: 0.7,
      }
    )

    intersectionElement.observe(element)

    return () => {
      intersectionElement.unobserve(element)
    }
  }, [sellers, elementRef])
}
